module.exports = __webpack_public_path__ + "static/logo_white-e9c7a4f12e28b79dcd9e73664f9bda5b.svg";